import DocumentMeta from 'react-document-meta';
import Styles from './styles.module.css';
import '../home/tokens.css';
import { useRef, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import React from "react";
import { addDoc, collection, getFirestore } from "firebase/firestore";
import Navigation from '../home/1.navigation/index';

// 営業目的の問い合わせで頻出する語。複数該当した場合のみ自動拒否する（誤検知を避けるため単発ヒットでは拒否しない）。
const SALES_NG_WORDS = ['SEO', '営業代行', '広告運用', '無料お試し', '配信停止', 'ご提案'];

const CONTENT_MIN_LENGTH = 20;
const CONTENT_MAX_LENGTH = 500;

const Contact: React.FC = () => {

  const [ progress, setProgress ] = useState(1);

  const [ name, setName ] = useState('');
  const [ company, setCompany ] = useState('');
  const [ mailAddress, setMailAddress ] = useState('');
  const [ tellPhone, setTellPhone ] = useState('');
  const [ content, setContent ] = useState('');

  // ハニーポット: 人間には見えない入力欄。ここが埋まっていればbotとみなす。
  const [ honeypot, setHoneypot ] = useState('');

  const [ alert, setAlert ] = useState(0);

  function confirmation() {
    const phoneRegex = /^[0-9-]+$/;
    const mailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    const urlCount = (content.match(/https?:\/\//g) || []).length;
    const contentUpper = content.toUpperCase();
    const ngWordCount = SALES_NG_WORDS.filter(word => contentUpper.includes(word.toUpperCase())).length;

    if (company === '') {
      setAlert(1);
    } else if (name === '') {
      setAlert(2);
    } else if (tellPhone === '') {
      setAlert(3);
    } else if (!phoneRegex.test(tellPhone)) {
      setAlert(6);
    } else if (mailAddress === '') {
      setAlert(4);
    } else if (!mailRegex.test(mailAddress)) {
      setAlert(7);
    } else if (content === '') {
      setAlert(5);
    } else if (content.trim().length < CONTENT_MIN_LENGTH) {
      setAlert(8);
    } else if (content.length > CONTENT_MAX_LENGTH) {
      setAlert(9);
    } else if (urlCount >= 2) {
      setAlert(10);
    } else if (ngWordCount >= 2) {
      setAlert(11);
    } else {
      setAlert(0);
      setProgress(2);
    }
  }

  async function update() {
    // botはハニーポット欄まで機械的に埋めてくることが多いため、埋まっていれば
    // 送信元には気づかせずに完了画面だけ見せて実際の送信は行わない。
    if (honeypot !== '') {
      setProgress(3);
      return;
    }

    const db = getFirestore();

    await addDoc(collection(db, "contacts"), {
      to: mailAddress,
      company: company,
      name: name,
      tellPhone: tellPhone,
      text: content,
      time: new Date(),
    });

    setProgress(3);
  }
  const problemRef = useRef(null);
  const serviceRef = useRef(null);
  const pointRef = useRef(null);
  const priceRef = useRef(null);
  const functionsRef = useRef(null);

  const scrollTo = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const meta = {
    title: "お問い合わせ | 株式会社memorii（memorii works）",
    description: "株式会社memoriiが提供する美容学生向け求人サイト「memorii works」へのお問い合わせページです。サービス内容や導入に関するご相談はこちらからご連絡ください。",
    canonical: "https://memorii-works.com/contact",
    meta: { charset: "utf-8" }
  };


  return (
    <>
    <DocumentMeta {...meta}>
      <Navigation 
        onScrollToProblem={() => scrollTo(problemRef)}
        onScrollToService={() => scrollTo(serviceRef)}
        onScrollToPoint={() => scrollTo(pointRef)}
        onScrollToFunctions={() => scrollTo(functionsRef)}
      />
      <div className={Styles.back}>
        <div className={Styles.head}>
          <span className={Styles.kicker}>CONTACT</span>
          <h1 className={Styles.title}>お問い合わせ</h1>
        </div>
        <div className={Styles.contents}>

          <div className={Styles.status}>
            <h4 className={progress === 1 ? Styles.status_check : Styles.status_uncheck}>① 入力</h4>
            <h4 className={progress === 2 ? Styles.status_check : Styles.status_uncheck}>② 確認</h4>
            <h4 className={progress === 3 ? Styles.status_check : Styles.status_uncheck}>③ 完了</h4>
          </div>

          {progress === 1  || progress === 2 ?
          <>
            <input
              type="text"
              name="website"
              value={honeypot}
              onChange={e => setHoneypot(e.target.value)}
              className={Styles.honeypot}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
            />
            <p className={Styles.notice}>
              営業、広告、SEO、採用支援、業務提携等のサービス提案を目的とした送信はご遠慮ください。営業目的と判断したお問い合わせには返信いたしません。また、繰り返し送信された場合は送信元情報を記録し、アクセスを制限する場合があります。
            </p>
            <div className={Styles.contents_box}>
              <h3>会社名<span>*</span></h3>
              {progress === 1 ?
                <input value={company} onChange={e => setCompany(e.target.value)} placeholder="株式会社memorii" />
                :
                <p>{company}</p>
              }
            </div>
            <p className={Styles.contents_alert} style={alert === 1 ? {display : 'block'} : {display : 'none'}}>※会社名を入力してください。</p>
            <div className={Styles.contents_box}>
              <h3>氏名<span>*</span></h3>
              {progress === 1 ?
                <input value={name} onChange={e => setName(e.target.value)} placeholder="メモリ 太郎" />
                :
                <p>{name}</p>
              }
            </div>
            <p className={Styles.contents_alert} style={alert === 2 ? {display : 'block'} : {display : 'none'}}>※氏名を入力してください。</p>
            <div className={Styles.contents_box}>
              <h3>電話番号<span>*</span></h3>
              {progress === 1 ?
                <input value={tellPhone} onChange={e => setTellPhone(e.target.value)} placeholder="080-xxxx-xxxx" />
                :
                <p>{tellPhone}</p>
              }
            </div>
            <p className={Styles.contents_alert} style={alert === 3 ? {display : 'block'} : {display : 'none'}}>※電話番号を入力してください。</p>
            <p className={Styles.contents_alert} style={alert === 6 ? {display : 'block'} : {display : 'none'}}>※半角数字のみで入力してください。</p>
            <div className={Styles.contents_box}>
              <h3>メールアドレス<span>*</span></h3>
              {progress === 1 ?
                <input value={mailAddress} onChange={e => setMailAddress(e.target.value)} placeholder="info@memorii-works.com" />
                :
                <p>{mailAddress}</p>
              }
            </div>
            <p className={Styles.contents_alert} style={alert === 4 ? {display : 'block'} : {display : 'none'}}>※メールアドレスを入力してください。</p>
            <p className={Styles.contents_alert} style={alert === 7 ? {display : 'block'} : {display : 'none'}}>※半角英数字で入力してください。</p>
            <div className={Styles.contents_box}>
              <h3>お問い合わせ内容<span>*</span></h3>
              {progress === 1 ?
                <TextareaAutosize className={Styles.contents_box_area} value={content} onChange={e => setContent(e.target.value)} placeholder="memorii worksに関する質問" maxLength={CONTENT_MAX_LENGTH} />
                :
                <p>{content}</p>
              }
            </div>
            {progress === 1 ?
              <p className={Styles.counter}>{content.length} / {CONTENT_MAX_LENGTH}文字（{CONTENT_MIN_LENGTH}文字以上でご入力ください）</p>
              : <></>
            }
            <p className={Styles.contents_alert} style={alert === 5 ? {display : 'block'} : {display : 'none'}}>※お問い合わせ内容を入力してください。</p>
            <p className={Styles.contents_alert} style={alert === 8 ? {display : 'block'} : {display : 'none'}}>※お問い合わせ内容は{CONTENT_MIN_LENGTH}文字以上でご入力ください。</p>
            <p className={Styles.contents_alert} style={alert === 9 ? {display : 'block'} : {display : 'none'}}>※お問い合わせ内容は{CONTENT_MAX_LENGTH}文字以内でご入力ください。</p>
            <p className={Styles.contents_alert} style={alert === 10 ? {display : 'block'} : {display : 'none'}}>※本文に含められるURLは1件までです。</p>
            <p className={Styles.contents_alert} style={alert === 11 ? {display : 'block'} : {display : 'none'}}>※営業目的のお問い合わせと判断したため、送信できません。</p>
            <p className={Styles.announce}><span>*</span>は必須マークです。全ての項目を入力してください。</p>
            {progress === 1 ?
              <button className={Styles.btn} onClick={() => confirmation()}>確認</button>
              :
              <button className={Styles.btn} onClick={() => update()}>送信</button>
            }
            {progress === 1 ? <></> :
              <h5 onClick={() => setProgress(1)} className={Styles.back_btn}>入力画面に戻る</h5>
            }
          </>
          :
          <>
          <p className={Styles.contents_third_btn}>
            弊社にご関心をお持ちいただき、ありがとうございます。<br />
            お問合せ内容の確認後、３営業日以内に担当者よりご連絡いたします。<br />
            引き続き何卒よろしくお願いいたします。
          </p>
          </> }
        </div>
      </div>
    </DocumentMeta>
    </>
  );
}

export default Contact;
